export default "__VITE_ASSET__2a4ce303__"